import portrait from "@/assets/jenifer-portrait.webp";
import portraitSmall from "@/assets/jenifer-portrait-480.webp";
import { Parallax } from "@/components/ui/Parallax";
import { FreeAuditButton } from "@/components/ui/Cta";
import { useContent } from "@/data/content";
import { useAppTranslation } from "@/i18n/useAppTranslation";

export function AboutSection() {
  const { about, home } = useContent();
  const { t } = useAppTranslation("legalPage");
  const intro = about.paragraphs.slice(0, 3);

  return (
    <section id="sobre-mi" aria-labelledby="about-heading" className="relative overflow-hidden bg-white">
      <div className="mx-auto grid max-w-7xl gap-14 px-4 py-24 sm:px-6 md:py-32 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20 lg:px-8">
        <div className="relative mx-auto w-full max-w-md lg:mx-0">
          <div aria-hidden="true" className="absolute -inset-10 rounded-full bg-[radial-gradient(circle,rgb(114_181_177/0.3),transparent_65%)]" />
          <Parallax distance={70} className="relative">
            <div className="overflow-hidden rounded-[2rem] shadow-lit-lg">
              <img
                src={portrait}
                srcSet={`${portraitSmall} 480w, ${portrait} 576w`}
                sizes="(min-width: 1024px) 28rem, 90vw"
                alt={t("aboutPhotoAlt")}
                width={576}
                height={1024}
                loading="lazy"
                decoding="async"
                className="aspect-[9/16] h-full w-full object-cover"
              />
            </div>
          </Parallax>
          <figure
            data-reveal=""
            style={{ ["--reveal-delay" as string]: "200ms" }}
            className="relative -mt-16 ml-auto w-[88%] rounded-3xl bg-brand-primary p-6 text-white shadow-lit-lg sm:p-7"
          >
            <blockquote className="font-display text-lg leading-snug sm:text-xl">“{home.about.quote}”</blockquote>
            <figcaption className="mt-4 text-sm text-teal-light">{home.about.signature}</figcaption>
          </figure>
        </div>

        <div className="lg:pt-6">
          <h2
            id="about-heading"
            data-reveal=""
            className="font-display text-[clamp(2rem,4vw,3.25rem)] font-semibold leading-[1.08] tracking-[-0.02em] text-brand-primary"
          >
            {about.title}
          </h2>
          <div className="mt-6 space-y-4 text-lg leading-relaxed text-ink-soft">
            {intro.map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
          </div>

          <h3 data-reveal="" className="mt-12 font-display text-2xl font-semibold text-brand-primary">
            {about.expectTitle}
          </h3>
          <dl className="mt-6 grid gap-x-8 gap-y-6 sm:grid-cols-2">
            {about.highlights.map((item, i) => (
              <div key={i} data-reveal="" style={{ ["--reveal-delay" as string]: `${i * 70}ms` }}>
                <dt className="node font-semibold text-brand-primary">{item.title}</dt>
                <dd className="mt-1.5 pl-[1.5em] leading-relaxed text-ink-soft">{item.description}</dd>
              </div>
            ))}
          </dl>

          <div data-reveal="" className="mt-10">
            <FreeAuditButton location="about" />
          </div>
        </div>
      </div>
    </section>
  );
}
